module.exports = __webpack_public_path__ + "img/network.0c71e13f.jpg";